var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
export default class Modal extends Component {
    constructor(props) {
        super(props);
        this._modalElement = null;
    }
    componentDidMount() {
        this._modalElement = $(`#${this.props.modalId}`);
        if (this.props.isOpen) {
            this._modalElement.modal("show");
        }
        this._modalElement.on("hide.bs.modal", () => this.props.onCloseModal());
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this._modalElement.modal(this.props.isOpen ? "show" : "hide");
        }
    }
    componentWillUnmount() {
        this._modalElement.modal("hide");
    }
    render() {
        const _a = this.props, { isOpen, modalId, onCloseModal, children, keyboard, backdrop, focus } = _a, otherProps = __rest(_a, ["isOpen", "modalId", "onCloseModal", "children", "keyboard", "backdrop", "focus"]); // eslint-disable-line no-unused-vars, max-len
        const config = {
            "data-keyboard": keyboard,
            "data-backdrop": backdrop,
            "data-focus": focus,
        };
        return (_jsx("div", Object.assign({ 
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number | undefined'.
            tabIndex: "-1", role: "dialog", "aria-hidden": !isOpen }, otherProps, { id: modalId, className: `modal fade ${
            // @ts-expect-error - TS2339 - Property 'className' does not exist on type '{}'. | TS2339 - Property 'className' does not exist on type '{}'.
            otherProps.className ? otherProps.className : ""}` }, config, { children: children })));
    }
}
